import React from 'react';

import NotificationRenderer from 'bdvp-common/src/components/NotificationRenderer';
import { useMediaConfig } from 'bdvp-common/src/hooks/config';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';

import Message from '../../containers/Message';
import Notification from '../Notification';

const NoSearch = () => {

    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.search) ?? {};

    return (
        <>
            <NotificationRenderer
                config={config}
                render={(id, contentConfig) => (
                    <Notification id={id} contentConfig={contentConfig} />
                )}
            />
            <Message type={'no_search_query'} />
        </>
    );

};

export default NoSearch;
